<template>
  <div>
    <label>
      {{$t('CONTENT.payments.payment_lease_rate')}}:
      <span class="b-form__required">*</span>
    </label>
    <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="newLeaseRate"></numeric>
  </div>
</template>

<script>
import ChangeRentRate from "../../models/commands/ChangeRentRate";

export default {
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newLeaseRate: 0
    };
  },
  created() {
    this.newLeaseRate = this.paymentParams.leaseRate;
  },
  methods: {
    cancel() {
      this.newLeaseRate = this.paymentParams.leaseRate;
    },

    save() {
      const command = new ChangeRentRate(
        this.paymentParams.idInDB,
        this.newLeaseRate
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
